import { getNotFoundImg } from "@outplayed/riot-assets";

export const TierListTableError = () => {
  return (
    <div className="flex items-center flex-col py-[80px] px-[12px] bg-purple-400 rounded-[3px]">
      <img className="h-[200px]" src={getNotFoundImg()} alt="Oops! Something is wrong!" />
      <div className="mt-[50px] mb-[40px] text-[16px] font-medium text-white text-center">
        {"Oops! Looks like theres no data here. Please try again later."}
      </div>
    </div>
  );
};
